import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//   import {
//     getAliyunOSSSignature
//   } from "api/v1";
export default {
  name: "aliyun-oss",
  props: {
    extensions: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      required: true
    },
    courseId: {
      type: String,
      required: true
    },
    courseName: {
      type: String,
      required: true
    },
    folderId: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    ispartner: {
      type: Number,
      default: 0
    },
    schoolcoursetypeid: {
      type: String,
      default: ""
    },
    handlePreview: Function
  },
  data: function data() {
    return {
      visible: false,
      // 是否显示上传对话框
      randomId: "oss_" + parseInt(Math.random() * 1000000),
      btn_select: "btn-" + parseInt(Math.random() * 1000000),
      btn_start: "btn-" + parseInt(Math.random() * 1000000),
      uploader: null,
      files: [],
      accessid: "",
      accesskey: "",
      host: "",
      userid: "",
      name: "",
      randomName: "",
      policy: "",
      signature: "",
      filename: "",
      key: "",
      callback: "",
      expire: 0,
      file_name: "",
      file_name_type: "local_name",
      already: false,
      userId: ["lmlam6pl5vextozukig", "abnam6pfq1ngyeom3cnyw", "0j4cadwpvz5o4lfqshzreg"],
      flieNumber: 0
    };
  },
  watch: {
    "files.length": function filesLength() {
      if (this.files.length === 0) {
        this.visible = false;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    // 初始化插件
    this.$nextTick(function () {
      _this.initialize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    // 移除所有文件
    this.doRemoveAllFiles();
    this.uploader.destroy();
  },
  computed: {
    auth: function auth() {
      var auth = this.$store.state.auth || {};
      return auth;
    }
  },
  methods: {
    handleClick: function handleClick(file) {
      this.handlePreview && this.handlePreview(file);
    },
    onBeforeCloseHandler: function onBeforeCloseHandler() {
      // 移除所有文件
      this.doRemoveAllFiles();
    },
    onStartHandler: function onStartHandler() {
      this.flieNumber = this.files.length; // console.log("文件数组长度:" + this.files.length);

      var isexit = this.userId.indexOf(this.auth.userId);

      if (this.files.length > 5 && isexit == -1) {
        this.$message("一次最多上传5个文件");
        return false;
      }

      if (this.uploader) {
        this.setUploadParam(this.uploader, "", false);
      }
    },
    doRemoveAllFiles: function doRemoveAllFiles() {
      for (var i = this.files.length - 1; i >= 0; i--) {
        this.uploader.removeFile(this.files[i]);
        this.files.splice(i, 1);
      }
    },
    doRemoveFielHandler: function doRemoveFielHandler(file) {
      var f = this.uploader.removeFile(file);

      if (f) {
        for (var i = this.files.length - 1; i >= 0; i--) {
          if (this.files[i].id === file.id) {
            this.files.splice(i, 1);
          }
        }
      }

      this.$emit("remove", file);
    },
    initialize: function initialize() {
      var msg = this.extensions && this.extensions.length ? this.extensions : "jpg,jpeg,gif,png,bmp,mp4,txt,pdf,ppt,pptx,doc,docx,rar,zip,7z,mp3,swf,ziph";
      var self = this;
      this.uploader = new plupload.Uploader({
        runtimes: "html5,flash,silverlight,html4",
        browse_button: this.btn_select,
        // multi_selection: false,
        // container: document.getElementById(this.randomId),
        flash_swf_url: "/assets/lib/AliyunOSS/Moxie.swf",
        silverlight_xap_url: "/assets/lib/AliyunOSS/Moxie.xap",
        url: location.protocol + "//oss.aliyuncs.com",
        filters: {
          mime_types: [// 只允许上传图片和zip,rar文件
          {
            title: "只允许上传jpg,jpeg,gif,png,mp4,txt,pdf,ppt,pptx,doc,docx,rar,zip,7z,mp3,xlsx,xls资源",
            extensions: this.extensions && this.extensions.length ? this.extensions : "jpg,jpeg,gif,png,mp4,txt,pdf,ppt,pptx,doc,docx,rar,zip,7z,mp3,swf,ziph,xlsx,xls"
          } // { title: "Zip files", extensions: "zip,rar" }
          ],
          max_file_size: "2048mb",
          // 最大只能上传2048mb的文件
          prevent_duplicates: true // 不允许选取重复文件

        },
        init: {
          PostInit: function PostInit() {// document.getElementById('postfiles').onclick = function () {
            //   this.set_upload_param(this.uploader, '', false);
            //   return false;
            // };
          },
          FilesAdded: function FilesAdded(up, files) {
            plupload.each(files, function (file) {
              self.files.push(file);
            });

            if (this.files.length) {
              self.visible = true;
            }
          },
          BeforeUpload: function BeforeUpload(up, file) {
            self.setUploadParam(up, file.name, true);
          },
          UploadProgress: function UploadProgress(up, file) {//
          },
          FileUploaded: function FileUploaded(up, file, info) {
            if (info.status == 200) {} else {
              self.$message.info(info.response);
            }
          },
          UploadComplete: function UploadComplete(up, file) {
            self.$nextTick(function () {
              // 隐藏上传框
              self.visible = false; // 清空上传文件队列

              self.files.length = 0;
              var name = this.flieNumber == 1 ? '文件上传成功' : '所有文件均上传成功';
              self.$message.success(name);
              self.$emit("done");
            });
          },
          Error: function Error(up, err) {
            if (err.code == plupload.FILE_SIZE_ERROR) {
              self.$message.error("选择的文件太大了, 最大支持文件大小2GB");
            } else if (err.code == plupload.FILE_EXTENSION_ERROR) {
              self.$message.error("仅支持" + msg + "文件"); // self.$message.error("仅支持.jpg、.jpeg、.png、.gif、.mp4、文件");
            } else if (err.code == plupload.FILE_DUPLICATE_ERROR) {
              self.$message.error("这个文件已经选择或者上传过了");
            } else {
              self.$message.error(err.response);
            }
          }
        }
      }); // 初始化上传插件

      this.uploader.init();
    },
    setUploadParam: function setUploadParam(up, filename, ret) {
      if (!ret) {
        var timestamp = Date.parse(new Date()) / 1000;

        if (this.expire < timestamp + 3) {
          this.getSignature().then(function (rst) {
            up.start();
          });
        } else {
          up.start();
        }
      } else {
        var new_multipart_params = {
          key: this.key + this.randomString(16) + this.getFileSuffix(filename),
          policy: this.policy,
          OSSAccessKeyId: this.accessid,
          success_action_status: "200",
          // 让服务端返回200,不然，默认会返回204
          callback: this.callback,
          signature: this.signature,
          "x:userid": this.userid,
          "x:name": this.changeDocExtension(filename),
          "x:courseid": this.courseId,
          "x:coursename": this.courseName,
          "x:folderid": this.folderId,
          "x:ispartner": this.ispartner,
          "x:schoolcoursetypeid": this.schoolcoursetypeid
        };
        up.setOption({
          url: this.host.replace(/^http:/, location.protocol),
          // 替换当前协议
          multipart_params: new_multipart_params
        });
      }
    },
    getUploadedFileName: function getUploadedFileName(filename) {
      if (this.file_name_type === "local_name") {
        var tmp_name = this.file_name;
        tmp_name = tmp_name.replace("${filename}", filename);
        return tmp_name;
      } else if (this.file_name_type === "random_name") {
        return this.file_name;
      }

      return;
    },
    getFileSuffix: function getFileSuffix(filename) {
      console.log("filename:" + filename);
      var pos = filename.lastIndexOf(".");
      var suffix = "";

      if (pos !== -1) {
        suffix = filename.substring(pos).toLowerCase();
      }

      return suffix;
    },
    randomString: function randomString(len) {
      len = len || 32;
      var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      var maxPos = chars.length;
      var pwd = "";

      for (var i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }

      return pwd;
    },
    getSignature: function getSignature() {
      var _this2 = this;

      // 可以判断当前expire是否超过了当前时间, 如果超过了当前时间,就重新取一下.3s 做为缓冲
      var timestamp = Date.parse(new Date()) / 1000;

      if (this.expire < timestamp + 3) {
        return this.$http.get(this.url).then(function (rst) {
          _this2.host = rst.host;
          _this2.policy = rst.policy;
          _this2.accessid = rst.accessid;
          _this2.signature = rst.signature;
          _this2.expire = Date.parse(new Date(rst.expire)) / 1000;
          _this2.callback = rst.callback;
          _this2.key = rst.dir;
          _this2.userid = rst.userid, _this2.name = rst.name, _this2.randomName = rst.random;
          return false;
        });
      }

      return Promise.resolve(true);
    },
    //改变文件后缀
    changeDocExtension: function changeDocExtension(key) {
      if (key == "") {
        return key;
      } else {
        var s = key.lastIndexOf(".");
        var extension = key.substring(s + 1).toLowerCase();
        return key.substring(0, s + 1) + extension;
      }
    }
  }
};